import React from "react";
import { Label } from "@rebass/forms";
import {ErrorMessage, FieldHelperProps, FieldMetaProps} from "formik";
import styled from "styled-components";
import {Card, Flex, Text} from "rebass";
import {LoadingIcon} from "../Icons/LoadingIcon";

export type InputHelperOptionalParameters = {
  label?: string;
  maxWidth?: string;
  minWidth?: string;
  inlineLabel?: boolean;
  loading?: boolean;
}

export const InputHelper: React.FC<
  {
    helpers: FieldHelperProps<any>;
    meta: FieldMetaProps<any>;
  } & InputHelperOptionalParameters
> = ({ children, label, helpers, meta , maxWidth= "100%", minWidth= "200px", inlineLabel=true, loading=false}) => {

  const inputField = (loading? <LoadingIcon size={32}/> :
    <div style={{position: "relative"}}>
      {children}
      <ErrorCard doDisplay={meta.touched} errorText={meta.error}/>
    </div>
  )

  return (
    <div style={{
      maxWidth: maxWidth,
      minWidth: minWidth,
      margin: "0 20px 25px 20px",
      paddingBottom: "3px",
      borderBottom: inlineLabel? "2px solid #F4F9FF":""
    }}>
      {inlineLabel?
        <Flex>
          <Text fontWeight="heading" fontSize={1} color="#2D3F47" height="26px" lineHeight="26px" width="200px" textAlign="end" paddingRight="25px">
            {label}
          </Text>

          {inputField}
        </Flex>
      :
        <>
          <Text fontWeight="heading" fontSize={1} color="#2D3F47" paddingBottom="6px">
            {label}
          </Text>

          {inputField}
        </>
      }

    </div>
  );
};


const ErrorCard: React.FC<{doDisplay: boolean, errorText?: string}> = ({doDisplay, errorText}) => {
  if (!doDisplay || errorText==undefined) return <></>

  return (
    <Text color="danger" sx={{position: "absolute", bottom: -25, z: 10, width: "300px"}}>
      {errorText}
    </Text>
  )
}


